import { render, staticRenderFns } from "./AlertsListComponent.vue?vue&type=template&id=d9ce28c6&scoped=true"
import script from "./AlertsListComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertsListComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AlertsListComponent.vue?vue&type=style&index=0&id=d9ce28c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ce28c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9ce28c6')) {
      api.createRecord('d9ce28c6', component.options)
    } else {
      api.reload('d9ce28c6', component.options)
    }
    module.hot.accept("./AlertsListComponent.vue?vue&type=template&id=d9ce28c6&scoped=true", function () {
      api.rerender('d9ce28c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/AppBarToolbarItems/contextMenus/alerts/AlertsListComponent.vue"
export default component.exports